import React, { Fragment } from 'react';
import { NavLink } from 'reactstrap';

const Logout = props => {
    const logout = () => {
        localStorage.clear()
        props.setAuthenticated(false)
    }
    return (
        <Fragment>
            <NavLink className='auth-nav-link auth-nav-link--plain' onClick={logout} href = "#">
                Logout
            </NavLink>
        </Fragment>
    );
}

export default Logout
